export class MapLatLng {
    public lat: number;
    public lng: number;
    public weight: number;

    constructor(lat: number, lng: number, weight: number = 1) {
        this.lat = lat;
        this.lng = lng;
        this.weight = weight;
    }
}
